(() => {
  if (window.airboostNewsletterLoaded) return;
  window.airboostNewsletterLoaded = true;
  const subscribedKey = 'airboost.newsletter.subscribed.v1';
  const dismissedKey = 'airboost.newsletter.dismissedUntil.v1';
  const confirmationKey = 'airboost.newsletter.confirmationShown.v1';
  const pendingKey = 'airboost.newsletter.pendingUntil.v1';
  const memory = {};
  const read = key => { try { return localStorage.getItem(key) || memory[key]; } catch { return memory[key]; } };
  const write = (key, value) => { memory[key] = String(value); try { localStorage.setItem(key, String(value)); } catch {} };
  const suppressed = () => read(subscribedKey) === '1' || Number(read(dismissedKey) || 0) > Date.now() || Number(read(pendingKey) || 0) > Date.now();
  function init(root = document) {
    root.querySelectorAll('[data-ab-newsletter]').forEach(block => {
      if (block.dataset.abInitialized) return;
      block.dataset.abInitialized = 'true';
      const editor = block.dataset.editor === 'true';
      const success = block.querySelector('[data-ab-success], [data-ab-subscribed]');
      if (success && !editor) { write(subscribedKey, '1'); write(pendingKey, '0'); }
      const form = block.querySelector('form');
      const error = block.querySelector('[data-ab-error]');
      if (error && !editor) write(pendingKey, '0');
      form?.addEventListener('submit', () => {
        if (!editor && form.checkValidity()) {
          write(confirmationKey, '0');
          write(pendingKey, Date.now() + 30 * 60 * 1000);
        }
      });
      const dialog = block.querySelector('dialog');
      if (!dialog) return;
      let timer;
      const close = () => {
        if (!editor) write(dismissedKey, Date.now() + Number(block.dataset.dismissDays || 30) * 86400000);
        clearTimeout(timer);
        dialog.close();
      };
      const open = () => { if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal(); };
      block.querySelector('[data-ab-close]').addEventListener('click', close);
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      });
      // Shopify renders the outcome only after the native POST/challenge completes.
      const confirmation = block.querySelector('[data-ab-success]');
      if (confirmation && !editor) {
        block.querySelector('.ab-newsletter__title').textContent = 'Danke für deine Anmeldung!';
        const intro = block.querySelector('.ab-newsletter__text');
        if (intro) intro.hidden = true;
        confirmation.textContent = confirmation.textContent.trim().replace(/^Danke für deine Anmeldung!\s*/, '');
        if (location.hash === '#' + form?.id && read(confirmationKey) !== '1') {
          write(confirmationKey, '1');
          open();
        }
      }
      if (error && location.hash === '#' + form?.id) {
        open();
      } else if (!editor && !suppressed()) {
        const attempt = () => {
          if (!block.isConnected || suppressed()) return;
          if (document.hidden || document.querySelector('dialog[open]') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '')) {
            timer = setTimeout(attempt, 2000); return;
          }
          open();
        };
        timer = setTimeout(attempt, Number(block.dataset.delay || 7) * 1000);
      }
      document.addEventListener('shopify:section:select', event => { if (editor && block.closest('#shopify-section-' + event.detail.sectionId)) open(); });
      document.addEventListener('shopify:section:deselect', () => { if (editor) dialog.close(); });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(block)) { clearTimeout(timer); dialog.close(); } });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
